import { BsModalRef } from 'ngx-bootstrap/modal/';
import { Component, Inject, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

// import { AutocompleteDataService } from '@app/services/autocomplete.service';
import { CDSMask } from '@app/utils/cds-mask';


import { BsModalService } from 'ngx-bootstrap/modal';
import { ProcessoDocumentoPendente } from '@app/models/processo-documento-pendente.model';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { ConsultasService } from '@app/services/consultas.service';
import { IdDescricao } from '@app/models/util/id-descricao';
import { ProcessoService } from '@app/services/processo.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-solicitar-documentos',
  templateUrl: './solicitar-documentos.component.html',
  styleUrls: ['./solicitar-documentos.component.scss']
})
export class SolicitarDocumentosComponent implements OnInit {

  aguardandoSolicitacao = false;
  // documentoDataService: AutocompleteDataService;
  searchStr: string;

  lstErros: string[];
  lstErros2: string[];
  cdsMask: CDSMask = new CDSMask();
  bsModalRef: BsModalRef;

  processoId: number;
  lstDocumento: IdDescricao[];
  lstDocumentoProcesso: ProcessoDocumentoPendente[];
  documentoProcesso: ProcessoDocumentoPendente = new ProcessoDocumentoPendente();
  processoDocumentoSelecionado: ProcessoDocumentoPendente;


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private processoService: ProcessoService,
    private modalService: BsModalService,
    private consultasService: ConsultasService,
    @Inject(ToastrService) private toastr: ToastrService
  ) {
  }

  ngOnInit() {
    this.router.events.subscribe(() => window.scrollTo(0, 0));

    this.route.parent.params.subscribe(
      (params: any) => {
        this.processoId = params['id'];
        this.obterDocumentos();
      });

    this.consultasService.consultar('DOCUMENTO').toPromise().then(data => this.lstDocumento = data);
  }


  inserir() {
    this.aguardandoSolicitacao = true;
    this.documentoProcesso.ProcessoId = this.processoId;
    this.processoService.solicitarDocumento(this.documentoProcesso).toPromise().then(
      () => {
        this.documentoProcesso = new ProcessoDocumentoPendente();
        this.searchStr = null;
        this.lstErros = null;
        this.obterDocumentos();
        this.aguardandoSolicitacao = false;
      },
      (data) => {
        if (data.error) {
          this.lstErros = data.error.errors;
        }
        this.aguardandoSolicitacao = false;
      }
    );
  }

  deletar(id: number, descricao: string) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja realmente deletar o documento: ' + descricao;
    this.bsModalRef.content.confirmar = () => {
      this.processoService.deletarSolicitacao(id).toPromise()
        .then(
          () => {
            this.obterDocumentos();
            this.toastr.error('Documento excluído com sucesso!');
          },
          (data) => this.toastr.error(data.errors[0])
        );
    };
  }

  obterDocumentos() {
    this.processoService.obterSolicitacoesPorProcesso(this.processoId).toPromise().then(data => this.lstDocumentoProcesso = data);
  }

  editar(template: TemplateRef<any>, processoDocumento: ProcessoDocumentoPendente) {
    this.lstErros2 = null;
    this.processoDocumentoSelecionado = Object.assign({}, processoDocumento);
    this.bsModalRef = this.modalService.show(template);
  }


  editarConfirmar() {
    this.processoService.alterarSolicitacaoDocumento(this.processoDocumentoSelecionado).toPromise().then(
      () => {
        this.bsModalRef.hide();
        this.obterDocumentos();
      },
      (data) => {
        if (data.error) {
          this.lstErros2 = data.error.errors;
        }
      }
    );
  }
}
